module.exports = __webpack_public_path__ + "static/img/aqzs13.e2da41df.jpg";